var UpdateAppURLHelper, usePushState;

module.exports = UpdateAppURLHelper = function(adjustedURL, opts) {
  var ref;
  if (opts == null) {
    opts = {};
  }
  if (usePushState(opts)) {
    return window.history.pushState(null, null, adjustedURL);
  } else if (((ref = window.history) != null ? ref.replaceState : void 0) != null) {
    return window.history.replaceState(null, null, adjustedURL);
  } else {
    return window.location = adjustedURL;
  }
};

usePushState = function(opts) {
  var ref;
  if (!opts.pushState) {
    return false;
  }
  return ((ref = window.history) != null ? ref.pushState : void 0) != null;
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWRjYWJhbGxlcm8vbmFwaXN0cmFuby9idWlsZC8xNDkyNDY3OTc1Mzc5LTM3OTUyL3N0YWdpbmctMjAxNy4wNC4xN18yMi4xNS9nb29kcy9tb2R1bGVzL3NoYXJlZC9mcm9udGVuZC9oZWxwZXJzL2FwcF91cmwuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvYWRjYWJhbGxlcm8vbmFwaXN0cmFuby9idWlsZC8xNDkyNDY3OTc1Mzc5LTM3OTUyL3N0YWdpbmctMjAxNy4wNC4xN18yMi4xNS9nb29kcy9tb2R1bGVzL3NoYXJlZC9mcm9udGVuZC9oZWxwZXJzL2FwcF91cmwuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsTUFBTSxDQUFDLE9BQVAsR0FBaUIsa0JBQUEsR0FBcUIsU0FBQyxXQUFELEVBQWMsSUFBZDtBQUNwQyxNQUFBOztJQURrRCxPQUFLOztFQUN2RCxJQUFHLFlBQUEsQ0FBYSxJQUFiLENBQUg7V0FDRSxNQUFNLENBQUMsT0FBTyxDQUFDLFNBQWYsQ0FBeUIsSUFBekIsRUFBK0IsSUFBL0IsRUFBcUMsV0FBckMsRUFERjtHQUFBLE1BRUssSUFBRyxvRUFBSDtXQUNILE1BQU0sQ0FBQyxPQUFPLENBQUMsWUFBZixDQUE0QixJQUE1QixFQUFrQyxJQUFsQyxFQUF3QyxXQUF4QyxFQURHO0dBQUEsTUFBQTtXQUdILE1BQU0sQ0FBQyxRQUFQLEdBQWtCLFlBSGY7O0FBSCtCOztBQVF0QyxZQUFBLEdBQWUsU0FBQyxJQUFEO0FBQ2IsTUFBQTtFQUFBLElBQUEsQ0FBb0IsSUFBSSxDQUFDLFNBQXpCO0FBQUEsV0FBTyxNQUFQOztTQUNBO0FBRmEifQ==
